import { gql } from '@apollo/client'

export const Query = gql`
  query MaintenanceTypes(
    $companyId: ID!, 
    $filters: MaintenanceTypeFilters, 
    $after: String, 
    $before: String, 
    $first: Int, 
    $last: Int
  ) {
    maintenanceTypes(
      companyId: $companyId, 
      filters: $filters, 
      after: $after, 
      before: $before, 
      first: $first, 
      last: $last
    ) {
      nodes {
        id
        maintenanceTypeTasks { 
          id
        }
        color
        name
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
